import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@src/environments/environment';
import {PublicAccount, PublicVehicle, PublishedVehicleDetails, PublishedVehicleViews, SingleResult} from '@app/interfaces';
import {VirtualGarageSettings} from "@app/interfaces/entities/advertising/VirtualGarageSettings";
import {AdvertisingForm} from '@app/interfaces/entities/advertising-form';

@Injectable({
  providedIn: 'root'
})
export class VirtualSalonApiService {

  constructor(private http: HttpClient,
              @Inject(LOCALE_ID) private locale: string,
  ) {
  }

  getPublishedVehicle(vehicleUuid: string) {
    return this.http.get<SingleResult<{
      publicAccount: PublicAccount,
      publicVehicle: PublicVehicle,
      publishedVehicleDetails: PublishedVehicleDetails,
      totalViews: number
      viewCounts: PublishedVehicleViews[]
    }>>(`${environment.apiUrl}/api/virtual-salon/published-vehicle/${vehicleUuid}`);
  }

  getPublishedVehicles() {
    return this.http.get<SingleResult<{ publicVehicles: PublicVehicle[], publishedVehiclesDetails: PublishedVehicleDetails[], publicAccount: PublicAccount }
    >>(`${environment.apiUrl}/api/virtual-salon/published-vehicles`);
  }


  getVirtualGarageSettings(accountUuid?: string): Observable<SingleResult<VirtualGarageSettings>> {
    return this.http.post<SingleResult<VirtualGarageSettings>>(`${environment.apiUrl}/api/virtual-salon/settings`, {accountUuid});
  }

  updateVirtualGarageSettings(accountUuid: string, settings: any) {
    return this.http.post<SingleResult<VirtualGarageSettings>>(`${environment.apiUrl}/api/virtual-salon/settings/update`, {...settings, accountUuid});
  }

  getForm(businessUnitUuid?: string): Observable<SingleResult<AdvertisingForm>> {
    let params = new HttpParams();
    if (businessUnitUuid) {
      params = params.append('businessUnitUuid', businessUnitUuid);
    }

    return this.http.get<SingleResult<AdvertisingForm>>(`${environment.apiUrl}/api/virtual-salon/settings/form`, {params});
  }

  saveForm(fields: { [key: string]: any }, businessUnitUuid?: string): Observable<SingleResult<unknown>> {
    return this.http.post<SingleResult<unknown>>(`${environment.apiUrl}/api/virtual-salon/settings/form`, {...fields, businessUnitUuid});
  }

  uploadLogo(file: File): Observable<SingleResult<{ logoUrl: string | null }>> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<SingleResult<{ logoUrl: string | null }>>(`${environment.apiUrl}/api/virtual-salon/logo`, formData);
  }

  deleteLogo(): Observable<SingleResult<{ logoUrl: string | null }>> {
    return this.http.delete<SingleResult<{ logoUrl: string | null }>>(`${environment.apiUrl}/api/virtual-salon/logo`);
  }

  uploadPrivacyPolicyFile(file: File): Observable<SingleResult<{ privacyPolicyFileUrl: string | null }>> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<SingleResult<{ privacyPolicyFileUrl: string | null }>>(`${environment.apiUrl}/api/virtual-salon/privacy-policy-file`, formData);
  }

  deletePrivacyPolicyFile(): Observable<SingleResult<{ privacyPolicyFileUrl: string | null }>> {
    return this.http.delete<SingleResult<{ privacyPolicyFileUrl: string | null }>>(`${environment.apiUrl}/api/virtual-salon/privacy-policy-file`);
  }
}

